import { render, staticRenderFns } from "./c_player_registInfo_details.vue?vue&type=template&id=468bdcd6&scoped=true"
import script from "./c_player_registInfo_details.vue?vue&type=script&lang=js"
export * from "./c_player_registInfo_details.vue?vue&type=script&lang=js"
import style0 from "./c_player_registInfo_details.vue?vue&type=style&index=0&id=468bdcd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468bdcd6",
  null
  
)

export default component.exports